import React from "react";
import "./T3.css";

export default function T3({
  name,
  title,
  subtitle,
  subtitle_2,
  description,
  description_2,
  info,
  info_2,
  image_url,
  image_url_2,
  // novos campos
  link_url,
  link_url_2,
  link_tag,
  link_tag_2,
}) {
  const has1 = Boolean(image_url);
  const has2 = Boolean(image_url_2);
  const variant = !has1 && !has2 ? "is-none" : has1 && has2 ? "is-two" : "is-one";

  const links = [
    { url: link_url, tag: link_tag },
    { url: link_url_2, tag: link_tag_2 },
  ].filter(l => !!l.url);

  return (
    <section className="t3-root">
      {/* decorações */}
      <div className="t3-deco t3-deco--tl" />
      <div className="t3-deco t3-deco--br" />

      <div className="t3-container">
        {/* ESQUERDA: vitrine de imagens */}
        <div className="t3-left">
          <div className={`t3-images ${variant}`}>
            {has1 && (
              <figure className="t3-media">
                <img className="t3-img" src={image_url} alt="" />
              </figure>
            )}
            {has2 && (
              <figure className="t3-media">
                <img className="t3-img" src={image_url_2} alt="" />
              </figure>
            )}
            {!has1 && !has2 && <div className="t3-media-placeholder" />}
          </div>
        </div>

        {/* DIREITA: painel com LOGO (topo) + TEXTOS (abaixo) */}
        <div className="t3-right">
          {/* LOGO alinhada ao painel de textos, largura total */}
          <div className="t3-brand-bar" aria-label="Sirrus">
            <img src="/brand/brand-1.svg" alt="Sirrus" />
          </div>

          {/* Cartão de textos ocupa o restante do painel */}
          <div className="t3-panel">
            {name && <p className="t3-overline">{name}</p>}
            {title && <h1 className="t3-title">{title}</h1>}
            {subtitle && <p className="t3-subtitle">{subtitle}</p>}
            {subtitle_2 && <p className="t3-subtitle2">{subtitle_2}</p>}
            {description && <p className="t3-body">{description}</p>}
            {description_2 && <p className="t3-body">{description_2}</p>}

            {(links.length > 0 || info || info_2) && (
              <div className="t3-meta">
                {/* LINKS primeiro, estilo distinto */}
                {links.length > 0 && (
                  <div className="t3-links">
                    {links.map((l, i) => (
                      <a
                        key={`t3-link-${i}`}
                        className="t3-linkpill"
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={l.url}
                      >
                        <span className="t3-link-icon" aria-hidden>🔗</span>
                        <span>{(l.tag && l.tag.trim()) || l.url}</span>
                      </a>
                    ))}
                  </div>
                )}

                {/* Infos depois dos links, na mesma linha/bloque */}
                {(info || info_2) && (
                  <div className="t3-chips">
                    {info && <span className="t3-chip">{info}</span>}
                    {info_2 && <span className="t3-chip">{info_2}</span>}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
